import { render, staticRenderFns } from "./scale.vue?vue&type=template&id=8c2336ac&"
import script from "./scale.vue?vue&type=script&lang=js&"
export * from "./scale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports